/* istanbul ignore file */
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import useAssetService, { UPDATE_ASSET_ASSIGNMENT } from 'domain/finance/assets/useAssetService';

const ReturnToStorageAssetButton = () => {
  const { data, setData = () => {} } = useShowContext();
  const assetId = data.getValueBySource('inventoryNumber');
  const assignmentDetails = data.getValueBySource('assignmentDetails');
  const hasOwner = !!assignmentDetails?.currentOwner;
  const { updateAssignmentDetails } = useAssetService();

  if (!hasOwner) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      permissionToCheck={UPDATE_ASSET_ASSIGNMENT}
      displayMessage="Do you really want to return this asset to storage?"
      submitMethod={() => updateAssignmentDetails(assetId, { assignmentDetails: null })}
      afterSubmit={{
        successMessage: 'The Asset has been successfully returned to storage.',
        errorMessage: "Can't return this asset to storage.",
        execute: (response: any) => {
          setData(response);
        },
      }}
      variant="outlined"
      sx={{ ml: 1.5 }}
      color="error"
    >
      Return to storage
    </ButtonWithConfirmation>
  );
};

export default ReturnToStorageAssetButton;
